import React from 'react';
import { AlertCircle, Wrench } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const UnderConstruction = () => {
  const { t } = useLanguage();
  
  return (
    <div className="bg-gradient-to-r from-[#ffb84d] via-[#ff9900] to-[#ffb84d] text-black py-3 px-4 relative overflow-hidden">
      {/* Animated background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-full" style={{
          backgroundImage: `repeating-linear-gradient(
            45deg,
            transparent,
            transparent 20px,
            rgba(0,0,0,.1) 20px,
            rgba(0,0,0,.1) 40px
          )`
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="flex items-center justify-center space-x-3 text-center">
          <Wrench className="animate-pulse hidden sm:block" size={24} />
          <div className="flex items-center space-x-2 flex-wrap justify-center">
            <AlertCircle size={20} className="flex-shrink-0" />
            <span className="text-sm sm:text-base font-black uppercase tracking-wide">
              {t('underConstruction.message')}
            </span>
            <span className="hidden sm:inline text-sm font-semibold">
              • {t('underConstruction.subtitle')}
            </span>
          </div>
          <Wrench className="animate-pulse hidden sm:block" size={24} />
        </div>
      </div>
    </div>
  );
};

export default UnderConstruction;
